<template>
  <div>
    <mheader></mheader>
    <div class="breadcrumb">
      <router-link to="/">Home</router-link> / Friend Links
      <!-- <a-breadcrumb>
        <a-breadcrumb-item><router-link to="/">Home</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>Friend Links</a-breadcrumb-item>
      </a-breadcrumb> -->
    </div>
    <h1 class="title">
      <!-- MLDIE's Friends -->
    </h1>
    <div v-if="!friendLink.length" class="empty">
      <a-icon class="icon" type="compass" /><br />
      vacant
    </div>
    <div class="links">
      <span class="linkItem" v-for="item in friendLink" :key="item.id">
        <a-tooltip v-if="item.description">
          <template slot="title">
            {{item.description}}
          </template>
          <a :href="item.url" target="_blank">
            <img v-if="item.avatar" :src="item.avatar"/>
            {{item.name}}
          </a>
        </a-tooltip>
        
        <a :href="item.url" v-else target="_blank">
          <img v-if="item.avatar" :src="item.avatar"/>
          {{item.name}}
        </a>
      </span>
      <span class="linkItem">
        <a-tooltip>
          <template slot="title">
            Show My Website! ‎(๑¯∀¯๑)
          </template>
          <a @click="toggleVisible(true)"><a-icon type="user-add" /></a>
        </a-tooltip>
      </span>
    </div>
    <mfooter></mfooter>

    <a-modal v-model="visible" title="Show My Website! ‎(๑¯∀¯๑)" destroyOnClose @ok="handleOk">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="Name">
          <a-input allow-clear
            v-decorator="['name', { rules: [{ required: true, message: 'Please input your website name!' }] }]"
          />
        </a-form-item>
        <a-form-item label="Url">
          <a-input allow-clear
            v-decorator="['url', { rules: [{ required: true, message: 'Please input your website url!' }] }]"
          />
        </a-form-item>
        <a-form-item label="Avatar">
          <a-input allow-clear
            v-decorator="['avatar']"
            placeholder="Avatar url"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-input allow-clear
            v-decorator="['description']"
            placeholder="One sentence description"
          />
        </a-form-item>
        <a-form-item label="Email">
          <a-input allow-clear
            v-decorator="['email', { rules: [
                { required: true, message: 'Please input your email!' },

                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import axios from '@/api';
import Mheader from '@/components/Mheader';
import Mfooter from '@/components/Mfooter';

export default {
  components: {
      Mheader,
      Mfooter,
  },
  data() {
    return {
      value: '# index',
      friendLink: [],
      visible: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'friendLink' }),
    }
  },
  computed: {
    language() {
      return localStorage.lang == 'en-US' ? 'en' : localStorage.lang;
    }
  },
  methods: {
    toggleVisible(flag) {
      this.visible = !!flag
    },
    handleOk(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          // this.$message.warning('Sorry, this feature is under development.')
          axios.applyFriendLink(values).then(() => {
            this.$message.success('Success! Thanks for your submission.')
            this.toggleVisible();
          })
        }
      });
    }
  },
  mounted() {
    axios.getFriendLink().then(res => {
      this.friendLink = res.data.list;
    });
  }
}
</script>

<style scoped>
.breadcrumb {
  margin-top: 3rem;
  color: #ccc;
}
.breadcrumb a {
  color: #999;
}
.breadcrumb a:hover {
  color: #1890ff;
}
.empty {
  font-size: 1.5rem;
  text-align: center;
}
.empty .icon {
  font-size: 3rem;
}
.title {
  text-align: center;
  font-weight: bold;
  margin-top: 3rem;
  /* color: #777; */
  color: rgba(1, 1, 1, .5)
}
.links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.links span.linkItem {
  display: inline-block;
  flex: 0 1 auto;
  /* font-size: 1.5rem; */
  line-height: 1.5rem;
  padding: 1.5rem;
  vertical-align: middle;
}

.links span.linkItem img {
  display: inline-block;
  width: 1.5rem;
  margin-right: 0;
  max-height: 1.5rem;
}
</style>
